import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c5d0d1d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5d0d1d')) {
      api.createRecord('0c5d0d1d', component.options)
    } else {
      api.reload('0c5d0d1d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c5d0d1d", function () {
      api.rerender('0c5d0d1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/supplier-shop/index.vue"
export default component.exports